module.exports = __webpack_public_path__ + "img/logo18.6ddaf238.png";